import { Announcement as ApiAnnouncement } from "../api-entities/Announcement";

export type Announcement = {
	text: string;
};

// api specifies announcements are provided pre-sorted and pre-filtered
export const makeAnnouncements = (announcements: ApiAnnouncement[]): Announcement[] => {
	return announcements.map(a => ({ text: a.text }));
};
